import { useMutation } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';
import { IScanPackageToRemoveData } from '../../../types';

/**
 * This is to track the mutation key for scan package to remove
 */
const MUT_SCAN_PACKAGE_TO_REMOVE = 'scan-package-to-remove-mutation-key';

interface IUpdateBidMutationParam {
  onSuccess: (updatedBidsData: IScanPackageToRemoveData) => void;
  onError: (err: IApiError) => void;
}

/**
 * React Query mutation function for removing package from inventory to black box
 */
export const useScanPackageToRemoveMutation = ({
  onSuccess,
  onError,
}: IUpdateBidMutationParam) => {
  const { isPending, isError, error, data, mutate, reset } = useMutation({
    mutationKey: [MUT_SCAN_PACKAGE_TO_REMOVE],
    networkMode: 'always',
    mutationFn: INV_MGMT_SERVICE_API.scanPackageToRemove,
    onSuccess,
    onError,
  });

  return {
    data,
    error,
    isError,
    isPending,
    resetScanPackageToRemove: reset,
    scanPackageToRemove: mutate,
  };
};
